var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSorting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 10 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0385 4.3759L17.4222 8.79306C17.6006 9.01615 17.8349 9.09423 18.1249 9.0273C18.4149 8.96037 18.5822 8.7819 18.6268 8.49189C18.6938 8.20187 18.6157 7.96763 18.3926 7.78916L12.8377 2.20078C12.7038 2.06693 12.5365 2 12.3357 2C12.1349 2 11.9676 2.06693 11.8338 2.20078L6.2454 7.78916C6.11154 7.92301 6.04462 8.09033 6.04462 8.29111C6.04462 8.49189 6.11154 8.65921 6.2454 8.79306C6.37925 8.92691 6.54657 8.99384 6.74735 8.99384C6.94813 8.99384 7.11544 8.92691 7.2493 8.79306L11.633 4.3759L11.633 19.6241L7.2493 15.2404C7.07083 15.0173 6.83658 14.9392 6.54657 15.0062C6.25655 15.0731 6.07808 15.2516 6.01115 15.5416C5.96654 15.8316 6.05577 16.0658 6.27886 16.2443L11.8338 21.7992C11.9676 21.9331 12.1349 22 12.3357 22C12.5365 22 12.7038 21.9331 12.8377 21.7992L18.4261 16.2443C18.5599 16.1105 18.6268 15.9431 18.6268 15.7424C18.6268 15.5416 18.5599 15.3743 18.4261 15.2404C18.2922 15.1066 18.1249 15.0396 17.9241 15.0396C17.7233 15.0396 17.556 15.1066 17.4222 15.2404L13.0385 19.6241L13.0385 4.3759Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSorting);
export default __webpack_public_path__ + "static/media/ArrowSorting.ed9a32d70358c13cedee917c26abd428.svg";
export { ForwardRef as ReactComponent };